import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, X, Rocket } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export const OnboardingChecklist = () => {
  const { user, brand } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { if (user?.tenant) api.get("/tenant/onboarding").then((r) => setD(r.data)).catch(() => {}); }, [user]);
  if (!d?.show) return null;
  const done = d.items.filter((i) => i.done).length;
  const dismiss = () => api.post("/tenant/onboarding/dismiss").then(() => setD({ ...d, show: false }));
  return (
    <div className="border border-slate-200 bg-white mb-8" data-testid="onboarding-checklist">
      <div className="px-5 py-4 border-b border-slate-100 flex items-start gap-3">
        <div className="w-9 h-9 brand-active text-white flex items-center justify-center shrink-0"><Rocket size={16} /></div>
        <div className="flex-1">
          <div className="font-heading text-lg text-slate-900">Willkommen bei {brand?.portal_name || "deinem Portal"}</div>
          <div className="text-xs text-slate-500">In wenigen Schritten startklar – {done} von {d.items.length} erledigt.</div>
          <div className="h-1.5 bg-slate-100 mt-2"><div className="h-full brand-active transition-[width] duration-500" style={{ width: `${(done / d.items.length) * 100}%` }} /></div>
        </div>
        <button onClick={dismiss} className="p-1 text-slate-400 hover:text-slate-700" title="Ausblenden" data-testid="onboarding-dismiss"><X size={16} /></button>
      </div>
      <ul className="divide-y divide-slate-100">
        {d.items.map((i) => (
          <li key={i.key}>
            <Link to={i.to} className="flex items-center gap-3 px-5 py-3 text-sm hover:bg-slate-50" data-testid={`onboarding-item-${i.key}`}>
              {i.done ? <CheckCircle2 size={17} className="text-emerald-600" /> : <Circle size={17} className="text-slate-300" />}
              <span className={i.done ? "text-slate-400 line-through" : "text-slate-800"}>{i.label}</span>
              {!i.done && <span className="ml-auto text-[11px] text-slate-500">Jetzt erledigen →</span>}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
